// src/pages/Settings.jsx
import React, { useState } from 'react';
import { FiSettings } from 'react-icons/fi';

import CompanyProfileTab from '../components/settings/CompanyProfileTab';
import RequestWidgetTab from '../components/settings/RequestWidgetTab'; // ✅ NEW
import TeamManagementTab from '../components/settings/TeamManagementTab';
import BillingTab from '../components/settings/BillingTab';
import SecurityTab from '../components/settings/SecurityTab';

const tabs = [
  { id: 'company', label: 'Company Profile' },
  { id: 'requestWidget', label: 'Request Widget' }, // ✅ NEW
  { id: 'team', label: 'Team Management' },
  { id: 'billing', label: 'Billing & Subscription' },
  { id: 'security', label: 'Security Settings' },
];

const tabDescriptions = {
  requestWidget: 'Configure your public request widget and embed it on your website.',
  security: 'Authentication, password rules and access controls.',
};

const Settings = () => {
  const [activeTab, setActiveTab] = useState('company');

  const renderTab = () => {
    switch (activeTab) {
      case 'company':
        return <CompanyProfileTab />;
      case 'requestWidget':
        return <RequestWidgetTab />;
      case 'team':
        return <TeamManagementTab />;
      case 'billing':
        return <BillingTab />;
      case 'security':
        return <SecurityTab />;
      default:
        return null;
    }
  };

  const activeDescription = tabDescriptions[activeTab];

  return (
    <div className="w-full min-h-[90vh] bg-slate-50 py-8 px-3 sm:px-6 lg:px-8">
      {/* Outer shell */}
      <div className="w-full rounded-2xl border border-slate-200 bg-white shadow-sm">
        <div className="p-6 sm:p-7">
          {/* Header */}
          <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
            <div>
              <div className="flex items-center gap-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-slate-900 text-white">
                  <FiSettings className="text-lg" />
                </div>
                <h1 className="text-2xl sm:text-3xl font-bold text-slate-900">
                  Settings
                </h1>
              </div>
              <p className="mt-1 text-sm text-slate-600">
                Configure your company, widget, team, billing and security.
              </p>
            </div>
          </div>

          {/* Tabs */}
          <div className="mt-6 border-b border-slate-200">
            <div className="flex flex-wrap items-center gap-5 text-sm font-medium">
              {tabs.map((tab) => {
                const isActive = tab.id === activeTab;
                return (
                  <button
                    key={tab.id}
                    type="button"
                    onClick={() => setActiveTab(tab.id)}
                    className={[
                      'relative pb-3 pt-2 transition-colors border-b-2',
                      isActive
                        ? 'border-blue-500 text-blue-700'
                        : 'border-transparent text-slate-500 hover:border-slate-200 hover:text-slate-900',
                    ].join(' ')}
                  >
                    {tab.label}
                  </button>
                );
              })}
            </div>
          </div>

          {/* Active tab description + content */}
          <div className="mt-6">
            {activeDescription && (
              <div className="mb-4">
                <p className="text-xs text-slate-500">{activeDescription}</p>
              </div>
            )}

            <div>{renderTab()}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
